import { useState } from "react";
import "../styles/rm-preview-popup.scss";
import { useSelector } from "react-redux";
import { GuiButton } from "../components/global-ui/gui-button";
import AudioPlayer from "../components/audio-player";
import { convertStringToJSX, useUpdateState } from "../utilities/utilities";
import { useOnFirstLoad } from "../utilities/hooks";
import actions from "../actions/actions";
import CircularProgress from "../actions/CircularProgress";
import user from "../actions/user-actions";
const RecentMessagePreviewPopup = ({
  previewModal,
  onClose,
  previewModalData,
  showToastViewOnly,
  isUserViewOnly = false,
}) => {
  let isMobile = useSelector((store) => store.page.isMobile);
  const [loading, setLoading] = useState(true);
  let [state, updateState] = useUpdateState(() => {
    return { audioUrl: "" };
  });
  useOnFirstLoad(() => {
    if (previewModalData.messageType !== "SMS Inbound") {
      const payload = {
        AlertId: previewModalData.alertId,
        IsMessageRead: true,
      };
      user.updateReadMessageProperty(payload).then((response) => {
        if (response.success) {
          if (previewModalData.messageType === "Voice") {
            convertTTS();
          } else {
            setLoading(false);
          }
        }
      });
    } else {
      setLoading(false);
    }
  });
  async function convertTTS() {
    var result = await actions.alerts.textToSpeech(
      previewModalData.messageDescription,
    );
    if (result.success) {
      updateState({ audioUrl: result.fileUrl });
      setLoading(false);
    }
    return result;
  }
  const onBtnClick = () => {
    actions.alerts.showDetails(previewModalData?.alertId);
  };

  return (
    <div className={`Modal ${previewModal ? "Show" : "hide"}`}>
      {loading ? (
        <CircularProgress
          className="circular-progress--dashboard"
          label="Loading message preview..."
        />
      ) : (
        <>
          <div className="modal-header">
            {isMobile && (
              <span onClick={onClose} className="mr-2">
                <i className="fa fa-chevron-left close-primary-icon cursor-pointer"></i>
              </span>
            )}
            <h4>Message Preview</h4>
            {!isMobile && (
              <span onClick={onClose}>
                <i className="fa fa-close close-primary-icon cursor-pointer"></i>
              </span>
            )}
          </div>
          <div className="modal-body">
            <div className="modal-body-title">
              {previewModalData.messageType}
              {previewModalData.subject &&
              previewModalData.subject.trim() !== ""
                ? ` - ${previewModalData.subject}`
                : ""}
            </div>
            <div className="rm-modal-footer-hr-divider"></div>
            <div className="modal-body-header">
              <div className="modal-body-header-avatar">
                <div className="initials">
                  {previewModalData.senderName
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
              </div>
              <div className="modal-body-header-title">
                <div className="modal-body-header-title-name">
                  {previewModalData.messageType !== "SMS Inbound" && (
                    <div className="name">{previewModalData.senderName}</div>
                  )}
                  {previewModalData.messageType === "SMS Inbound" &&
                    previewModalData.fromNumber && (
                      <div className="name">{previewModalData.fromNumber}</div>
                    )}
                  <div className="time">{previewModalData.dateTime}</div>
                </div>
                {previewModalData.messageType !== "SMS Inbound" && (
                  <div className="receiver-name">{`To: ${previewModalData.senderName}`}</div>
                )}
                {previewModalData.messageType === "SMS Inbound" &&
                  previewModalData.toNumber && (
                    <div className="receiver-name">{`To: ${previewModalData.toNumber}`}</div>
                  )}
              </div>
            </div>

            <div>
              {previewModalData.messageType === "Voice" ? (
                <AudioPlayer src={state.audioUrl} autoPlay={false} />
              ) : (
                convertStringToJSX(previewModalData.messageDescription)
              )}
            </div>
          </div>
          <div className="rm-modal-footer">
            <div className="rm-modal-footer-hr-divider"></div>
            <div className="rm-modal-footer-btns">
              <GuiButton className="cancel-btn" onClick={onClose}>
                Close
              </GuiButton>
              {previewModalData.messageType !== "SMS Inbound" && (
                <div
                  style={
                    isUserViewOnly
                      ? {
                          opacity: 0.6,
                        }
                      : {}
                  }
                >
                  <GuiButton
                    className="add-btn"
                    onClick={isUserViewOnly ? showToastViewOnly : onBtnClick}
                  >
                    View Message
                  </GuiButton>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RecentMessagePreviewPopup;
